import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal } from "./Weave";

const FAQS = [
  {
    q: "Is this the right moment — or am I getting ahead of myself?",
    a: "You're not in crisis — you're paying attention. And the good news is you don't need to answer this before you begin. Exploring with structure and support is exactly what Personal Clarity is for; you can't be ahead of yourself by gathering evidence.",
  },
  {
    q: "Can I actually afford the risk?",
    a: "Financially and professionally, that's a real question — so we treat it as one. Personal Clarity runs early evenings and at weekends, so your day job stays intact. In weeks six to eight a qualified IFA joins to work through the financial planning with you, and every full place carries a 14-day cancellation policy.",
  },
  {
    q: "What if it isn't for me?",
    a: "Personal Clarity is a complete, standalone programme — there's no obligation to continue. You leave with a conscious, informed decision about your next step, whatever that turns out to be, and the confidence to take it.",
  },
  {
    q: "Would I be starting from scratch?",
    a: "No. You'll map the skills, strengths, relationships and resources you already hold. Your Founder Capacity Index shows what carries forward, what you might be undervaluing, and what you'd want to develop next.",
  },
  {
    q: "How does this fit around my life?",
    a: "It's delivered online, in the early evenings and occasionally at weekends, with a mix of learning styles — and it's designed for senior professionals by ex-senior professionals who know what a demanding role and a full life look like. Ten weeks, a structured space, and a curriculum that works around the day job.",
  },
  {
    q: "What if I have no idea yet what I'd build?",
    a: "Perfect — no finished concept required. Personal Clarity is structured self-inquiry, not a business-plan bootcamp. You don't need to know you're a founder. You just need to be curious: could I be one?",
  },
];

export default function Faq() {
  return (
    <section id="faq" className="scroll-mt-24 bg-papermuted/60">
      <div className="mx-auto max-w-4xl px-4 py-16 sm:px-6 sm:py-24 lg:px-8 lg:py-32">
        <Reveal>
          <p className="mb-4 text-xs font-semibold uppercase tracking-[0.25em] text-tealdark">Before you begin</p>
          <h2 className="text-3xl font-bold tracking-tight text-ink sm:text-4xl lg:text-5xl">
            The questions keeping you up at night
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-body2">
            The good news: you don&rsquo;t need to answer any of them before you begin.
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible data-testid="faq-accordion" className="mt-12">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                data-testid="faq-item-accordion"
                className="border-ink/10"
              >
                <AccordionTrigger className="py-6 text-left text-lg font-semibold text-ink hover:text-tealdark hover:no-underline sm:text-xl">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-base leading-relaxed text-body2">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
